<template>
  <div class="input-source">
    <object
      id="av-player"
      class="tv-player__video"
      type="application/avplayer"
      v-if="getIsTizen"
    ></object>
    <object
      id="av-player"
      class="tv-player__video"
      v-if="getIsLG && getLGVersion >= '5.0'"
    ></object>
    <video
      id="av-player"
      class="tv-player__video"
      v-if="getLGVersion < '5.0'"
    ></video>
    <object
      id="av-player"
      class="tv-player__video"
      type="application/avplayer"
      v-if="getIsOrsay"
    ></object>
    <video
      v-if="!getIsOrsay && !getIsLG && !getIsTizen"
      class="tv-player__video"
      src="https://media.digmedia.net/website/video/rain_264.mp4?_=1"
      muted
      autoplay
      loop
    ></video>
    <transition v-bind:name="selectionMode ? 'fade' : ''">
      <div class="input-source__osd" v-if="showOSD">
        <div class="osd__header">
          <div class="osd-back" :class="{ 'osd-back--active': backButtonSelected }">
            <Icon color="#f1f1f1"><ArrowLeft></ArrowLeft></Icon> {{ getBack }}
          </div>
          <div class="tv-osd__header-title">
            <template v-if="!selectionMode">{{ source }} {{ port }}</template>
            <template v-else>HDMI Source Selection</template>
          </div>
        </div>
        
        <div v-if="selectionMode" class="source-selection">
          <div class="source-list">
            <div 
              v-for="(source, index) in hdmiSources" 
              :key="index"
              class="source-item"
              :class="{ 'source-item--active': selectedSourceIndex === index && !backButtonSelected }"
            >
              {{ source.name }}
            </div>
          </div>
          <div class="selection-instructions">
            <!--<p>Use UP/DOWN to navigate and ENTER to select a source</p>
            <p>Press UP from the first item to select the back button</p>-->
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DeviceType from '@/helpers/DeviceType';
import Icon from '@/components/Icon.vue';
import ArrowLeft from '@/assets/icons/WayfinderArrowLeft.vue';
import { keyHandler, KEYS } from '@/mixins/keyHandler';
import router from '@/router';
import { NAV_TYPE } from '@/store/modules/navigation';

export default {
  mixins: [keyHandler],
  components: { Icon, ArrowLeft },
  props: {
    source: String,
    port: Number | String,
    image: String,
    lang: Object,
  },
  emits: {},
  data() {
    return {
      showOSD: true,
      fadeOutTimer: 0,
      osdInterval: null,
      connectedVideoSources: [],
      selectionMode: true, // Start in selection mode
      hdmiSources: [], // List of available HDMI sources
      selectedSourceIndex: 0, // Currently selected source index
      currentSource: null, // Currently active source
      backButtonSelected: false, // Whether the back button is selected
    };
  },
  watch: {
    fadeOutTimer(value) {
      if (value >= 5000) {
        this.showOSD = false;
        clearInterval(this.osdInterval);
        this.fadeOutTimer = 0;
      }
    },
    showOSD(isTrue) {
      if (isTrue) {
        this.handleOSDFadeInOut();
      }
    },
  },
  mounted() {
    this.handleOSDFadeInOut();
    this.init();
    this.fetchHdmiSources();
  },
  beforeDestroy() {
    if(this.getIsTizen) {
      window.tizen.tvwindow.hide(this.callbackTizen, null, 'MAIN');
      this.removeInputSource();
    }
    if(this.getIsLG) {
      //window.lg.tvwindow.hide(this.callbackLG, null, 'MAIN');
      this.removeInputSource();
    }
    if(this.getIsOrsay) {
      //window.orsay.tvwindow.hide(this.callbackOrsay, null, 'MAIN');
      this.removeInputSource();
    }
  },
  methods: {
    init() {
      if (!this.selectionMode) {
        this.showInputSource();
      }
    },
    increaseFadeOutTimer() {
      this.fadeOutTimer += 1000;
    },
    getCurrentSource() {
      console.log("==============================getCurrentSource", this.currentSource);
      return this.currentSource;
    },
    handleOSDFadeInOut() {
      this.osdInterval = setInterval(this.increaseFadeOutTimer, 1000);
    },
    callbackTizen(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK TIZEN',
        message: JSON.stringify(context),
      });
    },
    callbackLG(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK LG',
        message: JSON.stringify(context),
      });
    },
    callbackOrsay(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK ORSAY',
        message: JSON.stringify(context),
      });
    },
    fetchHdmiSources() {
      if (this.getIsTizen) {
        this.fetchTizenHdmiSources();
      } else if (this.getIsLG) {
        this.fetchLGHdmiSources();
      } else if (this.getIsOrsay) {
        this.fetchOrsayHdmiSources();
      } else {
        // For browser testing
        this.hdmiSources = [
          { name: 'HDMI 1', type: 'HDMI', number: 1 },
          { name: 'HDMI 2', type: 'HDMI', number: 2 },
          { name: 'HDMI 3', type: 'HDMI', number: 3 },
          { name: 'HDMI 4', type: 'HDMI', number: 4 }
        ];
      }
    },
    
    fetchTizenHdmiSources() {
      try {
        window.tizen.systeminfo.getPropertyValue(
          'VIDEOSOURCE',
          (videoSource) => {
            this.connectedVideoSources = videoSource.connected;
            // Filter only HDMI sources
            this.hdmiSources = this.connectedVideoSources
              .filter(source => source.type === 'HDMI')
              .map(source => ({
                name: `HDMI ${source.number}`,
                type: source.type,
                number: source.number
              }));
            
            // Set initial selection to current source if it's HDMI
            if (this.source === 'HDMI') {
              const index = this.hdmiSources.findIndex(s => s.number === parseInt(this.port));
              if (index !== -1) {
                this.selectedSourceIndex = index;
              }
            }
          }
        );
      } catch (error) {
        console.log('Error fetching Tizen HDMI sources:', error.name, error.message);
      }
    },
    
    callbackTizenVideoSources(videoSource) {
      //console.log('==========callbackTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === this.source && el.number === this.port
        );
        if (!source) { console.error("========VS-ERR", videoSource); return; }
        console.log('SET SRC', source);
        this.currentSource = source;
        window.tizen.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    fetchLGHdmiSources() {
      try {
        hcap.externalinput.getExternalInputList({
          "onSuccess": (s) => {
            console.log("LG inputs list length = " + s.list.length);
            // Filter only HDMI sources
            this.hdmiSources = s.list
              .filter(source => source.type === hcap.externalinput.ExternalInputType.HDMI)
              .map(source => ({
                name: `HDMI ${source.index + 1}`,
                type: 'HDMI',
                number: source.index + 1,
                lgIndex: source.index
              }));
            
            // Set initial selection to current source if it's HDMI
            if (this.source === 'HDMI') {
              const index = this.hdmiSources.findIndex(s => s.number === parseInt(this.port));
              if (index !== -1) {
                this.selectedSourceIndex = index;
              }
            }
          },
          "onFailure": (f) => {
            console.log("Failed to get LG inputs: " + f.errorMessage);
          }
        });
      } catch (error) {
        console.log('Error fetching LG HDMI sources:', error);
      }
    },
    
    callbackLGVideoSources(videoSource) {
      //console.log('==========callbackTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === this.source && el.number === this.port
        );
        if (!source) return;
        console.log('SET SRC', source);
        this.currentSource = source;
        window.lg.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    fetchOrsayHdmiSources() {
      try {
        window.orsay.systeminfo.getPropertyValue(
          'VIDEOSOURCE',
          (videoSource) => {
            this.connectedVideoSources = videoSource.connected;
            // Filter only HDMI sources
            this.hdmiSources = this.connectedVideoSources
              .filter(source => source.type === 'HDMI')
              .map(source => ({
                name: `HDMI ${source.number}`,
                type: source.type,
                number: source.number
              }));
            
            // Set initial selection to current source if it's HDMI
            if (this.source === 'HDMI') {
              const index = this.hdmiSources.findIndex(s => s.number === parseInt(this.port));
              if (index !== -1) {
                this.selectedSourceIndex = index;
              }
            }
          }
        );
      } catch (error) {
        console.log('Error fetching Orsay HDMI sources:', error.name, error.message);
      }
    },
    
    callbackOrsayVideoSources(videoSource) {
      //console.log('==========callbackTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === this.source && el.number === this.port
        );
        if (!source) return;
        console.log('SET SRC', source);
        this.currentSource = source;
        window.orsay.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    selectSource() {
      if (this.hdmiSources.length === 0) return;
      
      const selectedSource = this.hdmiSources[this.selectedSourceIndex];
      this.port = selectedSource.number;
      this.selectionMode = false;
      this.backButtonSelected = false;
      
      if (this.getIsTizen) {
        this.selectTizenSource(selectedSource);
      } else if (this.getIsLG) {
        this.selectLGSource(selectedSource);
      } else if (this.getIsOrsay) {
        this.selectOrsaySource(selectedSource);
      }
    },
    
    selectTizenSource(selectedSource) {
      try {
        window.tizen.systeminfo.getPropertyValue(
          'VIDEOSOURCE',
          (videoSource) => {
            this.connectedVideoSources = videoSource.connected;
            const source = this.connectedVideoSources.find(
              (el) => el.type === selectedSource.type && el.number === selectedSource.number
            );
            
            if (!source) {
              console.error("Source not found", selectedSource);
              return;
            }
            
            console.log('Setting Tizen source:', source);
            this.currentSource = source;
            
            window.tizen.tvwindow.show(
              this.callbackTizen,
              (err) => {
                console.log('ERROR SHOW WINDOW', err);
              },
              ['0', '0', '100%', '100%'],
              'MAIN',
              'BEHIND'
            );
            
            window.tizen.tvwindow.setSource(source, () => {
              console.log('Tizen source set successfully');
            });
          }
        );
      } catch (error) {
        console.log('Error setting Tizen source:', error.name, error.message);
      }
    },
    
    selectLGSource(selectedSource) {
      try {
        console.log('Setting LG source:', selectedSource);
        
        hcap.externalinput.isExternalInputConnected({
          "type": hcap.externalinput.ExternalInputType.HDMI,
          "index": selectedSource.lgIndex || (selectedSource.number - 1),
          "onSuccess": (s) => {
            console.log("LG input connected =", s.isConnected);
            
            if (s.isConnected) {
              hcap.externalinput.setCurrentExternalInput({
                "type": hcap.externalinput.ExternalInputType.HDMI,
                "index": selectedSource.lgIndex || (selectedSource.number - 1),
                "onSuccess": (s) => {
                  console.log("LG source set successfully", s);
                  this.currentSource = selectedSource;
                },
                "onFailure": (f) => {
                  console.log("Failed to set LG source: " + f.errorMessage);
                }
              });
            } else {
              console.log("LG HDMI input not connected");
            }
          },
          "onFailure": (f) => {
            console.log("Failed to check LG input connection: " + f.errorMessage);
          }
        });
      } catch (error) {
        console.log('Error setting LG source:', error);
      }
    },
    
    selectOrsaySource(selectedSource) {
      try {
        window.orsay.systeminfo.getPropertyValue(
          'VIDEOSOURCE',
          (videoSource) => {
            this.connectedVideoSources = videoSource.connected;
            const source = this.connectedVideoSources.find(
              (el) => el.type === selectedSource.type && el.number === selectedSource.number
            );
            
            if (!source) {
              console.error("Source not found", selectedSource);
              return;
            }
            
            console.log('Setting Orsay source:', source);
            this.currentSource = source;
            
            window.orsay.tvwindow.show(
              this.callbackOrsay,
              (err) => {
                console.log('ERROR SHOW WINDOW', err);
              },
              ['0', '0', '100%', '100%'],
              'MAIN',
              'BEHIND'
            );
            
            window.orsay.tvwindow.setSource(source, () => {
              console.log('Orsay source set successfully');
            });
          }
        );
      } catch (error) {
        console.log('Error setting Orsay source:', error.name, error.message);
      }
    },
    
    showInputSource() {
      if(this.getIsTizen) {
        try {
          window.tizen.systeminfo.getPropertyValue(
            'VIDEOSOURCE',
            this.callbackTizenVideoSources
          );
          //console.log('==========showInputSource==========');
          window.tizen.tvwindow.show(
            this.callbackTizen,
            (err) => {
              console.log('ERROR SHOW WINDOW', err);
            },
            ['0', '0', '100%', '100%'],
            'MAIN',
            'BEHIND'
          );
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
      if(this.getIsLG) {
        try {
          console.log('==========showInputSource==========THIS=', parseInt(this.port));
          hcap.externalinput.isExternalInputConnected({
            "type": hcap.externalinput.ExternalInputType.HDMI,
            "index": this.port - 1,
            "onSuccess": (s) => {
                console.log("onSuccess : isConnected = " + s.isConnected);
                hcap.externalinput.setCurrentExternalInput({
                  "type": hcap.externalinput.ExternalInputType.HDMI,
                  "index": this.port - 1,
                  "onSuccess": (s) => {
                      console.log("onSuccess", s);
                      hcap.externalinput.getCurrentExternalInput({
                        "onSuccess": (s) => {
                            console.log("===onSuccess :" +
                                "\n type = " + s.type +
                                "\n index = " + s.index);
                        },
                        "onFailure": (f) => {
                            console.log("onFailure : errorMessage = " + f.errorMessage);
                        }
                      });
                  },
                  "onFailure": (f) => {
                      console.log("onFailure : errorMessage = " + f.errorMessage);
                  }
                });
            },
            "onFailure": (f) => {
                console.log("onFailure : errorMessage = " + f.errorMessage);
            }
          });
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
      if(this.getIsOrsay) {
        try {
          window.orsay.systeminfo.getPropertyValue(
            'VIDEOSOURCE',
            this.callbackOrsayVideoSources
          );
          //console.log('==========showInputSource==========');
          window.orsay.tvwindow.show(
            this.callbackTizen,
            (err) => {
              console.log('ERROR SHOW WINDOW', err);
            },
            ['0', '0', '100%', '100%'],
            'MAIN',
            'BEHIND'
          );
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
    },
    callbackRemoveTizenVideoSources(videoSource) {
      //console.log('==========callbackRemoveTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === 'TV' && el.number === 1
        );
        if (!source) return;
        console.log('SET SRC', source);
        window.tizen.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    callbackRemoveLGVideoSources(videoSource) {
      //console.log('==========callbackRemoveTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === 'TV' && el.number === 1
        );
        if (!source) return;
        console.log('SET SRC', source);
        window.lg.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    callbackRemoveOrsayVideoSources(videoSource) {
      //console.log('==========callbackRemoveTizenVideoSources==========videoSource=>', videoSource);
      this.connectedVideoSources = videoSource.connected;
      try {
        const source = this.connectedVideoSources.find(
          (el) => el.type === 'TV' && el.number === 1
        );
        if (!source) return;
        console.log('SET SRC', source);
        window.orsay.tvwindow.setSource(source, () =>
          console.log('SET SOURCE')
        );
      } catch (error) {
        console.log('COULDNT SET SOURCE: ', error.name, error.message);
      }
    },
    removeInputSource() {
      if(this.getIsTizen) {
        try {
          window.tizen.systeminfo.getPropertyValue(
            'VIDEOSOURCE',
            this.callbackRemoveTizenVideoSources
          );
          //console.log('==========removeInputSource==========');
          window.tizen.tvwindow.show(
            this.callbackTizen,
            (err) => {
              console.log('ERROR SHOW WINDOW', err);
            },
            ['0', '0', '100%', '100%'],
            'MAIN',
            'BEHIND'
          );
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
      if(this.getIsLG) {
        /*
        hcap.externalinput.getExternalInputList({
            "onSuccess": function (s) {
                console.log("onSuccess : list length = " + s.list.length);
                for (var i = 0; i < s.list.length; i++) {
                    console.log("(" + s.list[i].type + "," + s.list[i].index + "," + s.list[i].name + ")");
                }
            },
            "onFailure": function (f) {
                console.log("onFailure : errorMessage = " + f.errorMessage);
            }
        });
        */
        try {
          //console.log('==========removeInputSource==========');
          hcap.externalinput.setCurrentExternalInput({
            "type": hcap.externalinput.ExternalInputType.TV,//COMPONENT OTHERS RGB
            "index": 0,
            "onSuccess": function () {
                console.log("onSuccess");
            },
            "onFailure": function (f) {
                console.log("onFailure : errorMessage = " + f.errorMessage);
            }
          });
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
      if(this.getIsOrsay) {
        try {
          window.orsay.systeminfo.getPropertyValue(
            'VIDEOSOURCE',
            this.callbackRemoveOrsayVideoSources
          );
          //console.log('==========removeInputSource==========');
          window.orsay.tvwindow.show(
            this.callbackTizen,
            (err) => {
              console.log('ERROR SHOW WINDOW', err);
            },
            ['0', '0', '100%', '100%'],
            'MAIN',
            'BEHIND'
          );
        } catch (error) {
          console.log(
            'Error name = ' + error.name + ', Error message = ' + error.message
          );
        }
      }
    },
    eventHandler(key, event) {
      // Reset fade out timer and ensure OSD is visible
      this.fadeOutTimer = 0;
      this.showOSD = true;
      
      if (this.selectionMode) {
        // Handle navigation in selection mode
        switch (key) {
          case KEYS.UP:
            if (this.backButtonSelected) {
              // If back button is selected, move to the last source item
              this.backButtonSelected = false;
              this.selectedSourceIndex = this.hdmiSources.length - 1;
            } else if (this.selectedSourceIndex > 0) {
              this.selectedSourceIndex--;
            } else {
              // If at the first source item, select the back button
              this.backButtonSelected = true;
            }
            break;
            
          case KEYS.DOWN:
            if (this.backButtonSelected) {
              // If back button is selected, move to the first source item
              this.backButtonSelected = false;
              this.selectedSourceIndex = 0;
            } else if (this.selectedSourceIndex < this.hdmiSources.length - 1) {
              this.selectedSourceIndex++;
            } else {
              // If at the last source item, wrap to the back button
              this.backButtonSelected = true;
            }
            break;
            
          case KEYS.ENTER:
            if (this.backButtonSelected) {
              // If back button is selected, go back to the main page
              this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
            } else {
              // Otherwise select the source
              this.selectSource();
            }
            break;
            
          case KEYS.BACK:
            // Always go back to the main page when BACK is pressed
            this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
            break;
        }
      } else {
        // Handle keys when not in selection mode
        switch (key) {
          case KEYS.UP:
            // Select the back button when UP is pressed
            this.backButtonSelected = true;
            break;
            
          case KEYS.DOWN:
            // Deselect the back button when DOWN is pressed
            this.backButtonSelected = false;
            break;
            
          case KEYS.ENTER:
            if (!this.showOSD) {
              this.showOSD = true;
            } else if (this.backButtonSelected) {
              // If back button is selected, go back to the main page
              this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
            } else {
              // Return to selection mode
              this.selectionMode = true;
              this.backButtonSelected = false;
              this.fetchHdmiSources();
            }
            break;
            
          case KEYS.BACK:
            // Always go back to the main page when BACK is pressed
            this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
            break;
        }
      }
    },
  },
  computed: {
    getIsTizen() {
      return DeviceType.isTizen;
    },
    getLGVersion() {
      return window.lgVersion;
    },
    getIsLG() {
      return DeviceType.isLG;
    },
    getIsOrsay() {
      return DeviceType.isOrsay;
    },
    getBack() {
      return this.$i18n('back.name');
    },
  },
};
</script>

<style scoped>
.input-source {
  /*background: black;*/
  height: 100vh;
  position: relative;
  width: 100vw;
}
.input-source__osd {
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: 220;
}
.osd__header {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.7),
    transparent 40%,
    transparent
  );
  color: white;
  display: flex;
  font-size: 3vw;
  justify-content: space-between;
  padding: 0 40px;
  height: 120px;
  align-items: center;
}
.input-source__window {
  height: 100%;
  width: 100%;
  z-index: 1;
}

.tv-player__video {
  height: 100%;
  width: 100%;
}

.osd-back {
  font-size: 2vw;
  border: 2px solid transparent;
  padding: 10px 20px;
  transition: all 0.2s ease;
}
.osd-back--active {
  border-color: #f1f1f1;
  background-color: rgba(0, 120, 215, 0.8);
  box-shadow: 0 0 10px rgba(0, 120, 215, 0.5);
  transform: scale(1.05);
}

/* Source selection styles */
.source-selection {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 30px;
  width: 50%;
  max-width: 600px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.source-list {
  margin-bottom: 20px;
}

.source-item {
  color: white;
  font-size: 2.5vw;
  padding: 15px 20px;
  margin: 10px 0;
  border-radius: 5px;
  transition: all 0.2s ease;
  background-color: rgba(50, 50, 50, 0.5);
}

.source-item--active {
  background-color: rgba(0, 120, 215, 0.8);
  transform: scale(1.05);
  box-shadow: 0 0 10px rgba(0, 120, 215, 0.5);
}

.selection-instructions {
  color: #aaa;
  font-size: 1.5vw;
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.fade-enter-active {
  transition: all 0.1s ease-in-out;
}
.fade-leave-active {
  transition: all 0.6s ease-in-out;
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
.fade-leave,
.fade-enter-to {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/SourceSelect.vue